import { render, staticRenderFns } from "./RecordOrganizerConfigurator.vue?vue&type=template&id=52a6b216&scoped=true&"
import script from "./RecordOrganizerConfigurator.vue?vue&type=script&lang=js&"
export * from "./RecordOrganizerConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./RecordOrganizerConfigurator.vue?vue&type=style&index=0&id=52a6b216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6b216",
  null
  
)

export default component.exports